import React from 'react';
import { Clock } from 'lucide-react';

// Barra azul-marinho com a logo da Prefeitura + skyline de Corumbá — usada
// nas enquetes legadas (Portal de Entrada, Telão do Brasil), cada uma com
// sua própria cópia do markup. Extraído aqui pra ser reutilizado nas
// enquetes dinâmicas, que nunca tiveram esse header — sem tocar no
// markup já existente das páginas legadas (não mexer nelas é regra).
//
// isTimerActive/tempoFormatado (opcionais): mesmo comportamento herdado das
// legadas — cronômetro de preenchimento centralizado entre os dois logos,
// só aparece enquanto o formulário está sendo preenchido (quem calcula o
// valor é useFillTimer, no componente que usa este header).
const HeaderPrefeitura = ({ isTimerActive = false, tempoFormatado = '' }) => (
  <header className="bg-primary text-white shadow-lg">
    <div className="container-responsive py-6">
      <div className="relative flex items-center justify-center lg:justify-between">
        <a href="https://corumba.ms.gov.br/" target="_blank" rel="noopener noreferrer">
          <img
            src="/assets/logo_prefeitura_horizontal.png"
            alt="Prefeitura de Corumbá"
            className="h-12 w-auto hover:opacity-90 transition-opacity"
          />
        </a>

        {isTimerActive && (
          <div className="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 flex items-center space-x-1 text-primary-100">
            <Clock className="w-4 h-4" />
            <span className="text-sm">{tempoFormatado}</span>
          </div>
        )}

        <img
          src="/assets/background_corumba.png"
          alt="Corumbá"
          className="hidden lg:block h-12 w-auto"
        />
      </div>
    </div>
  </header>
);

export default HeaderPrefeitura;
